import { OnboardingSlide } from "@boundary/widgets/onboarding";
import { OnboardingMapStep } from "@boundary/pages/4.onboarding/steps/map";
import { OnboardingOrderStep } from "@boundary/pages/4.onboarding/steps/order";
import { OnboardingPickupStep } from "@boundary/pages/4.onboarding/steps/pickup";

export interface OnboardingFlowData {}

export type OnboardingFlowSteps = "map" | "order" | "pickup";

export const ONBOARDING_FLOW: OnboardingSlide<
  OnboardingFlowData,
  OnboardingFlowSteps
>[] = [
  {
    step: "map",
    element: OnboardingMapStep
  },
  {
    step: "order",
    element: OnboardingOrderStep
  },
  {
    step: "pickup",
    element: OnboardingPickupStep
  }
];

